import {Typography} from "@mui/material";

export const AppMenuBarInfoContent = () => {


    return {
        title: 'Contramatic',
        content: (
            <>
                <Typography paragraph>
                    Contramatic is a general-purpose contract administration
                    platform designed to automate the calculation,
                    administration, and fulfillment of ongoing contractual
                    obligations.
                </Typography>

                <ul>
                    <li>
                        The name <strong>Contramatic</strong> combines
                        <strong> Contra</strong> (Contract) and
                        <strong> matic</strong> (Automatic), reflecting
                        the system's goal of making contract administration
                        as automated as possible.
                    </li>

                    <li>
                        Contramatic is built upon contract models that
                        accurately represent the legal terms and business
                        rules contained within contractual agreements.
                    </li>

                    <li>
                        The system transforms those contractual terms into
                        individualized calculation models capable of
                        determining obligations, payments, adjustments,
                        and other contractual outcomes.
                    </li>

                    <li>
                        Contramatic is designed to make contract
                        administration understandable, transparent,
                        configurable, and auditable.
                    </li>

                    <li>
                        Every obligation can be traced back to the
                        contractual provisions, assumptions, inputs,
                        and calculations that produced it.
                    </li>

                    <li>
                        The platform supports the administration of
                        participations, residuals, royalties, and other
                        entertainment-industry contractual obligations.
                    </li>

                    <li>
                        Although preconfigured for entertainment industry
                        use cases, Contramatic can be adapted to virtually
                        any form of contract administration that requires
                        ongoing calculations, compliance, tracking,
                        reporting, and payment processing.
                    </li>

                    <li>
                        By combining contractual data, business rules,
                        financial activity, usage data, and other external
                        information, Contramatic provides a unified
                        framework for managing complex contractual
                        relationships throughout their lifecycle.
                    </li>
                </ul>
            </>
        )
    };

};

